import * as React from "react";
import * as ReactDom from "react-dom";
import * as Bouncer from "formbouncerjs";
import Login from "../components/views/Login";
import { emails } from "../config/constants";
import { checkLang, setCurrentPage } from "../services/general";
import { requestPageData } from "../services/api";

export const page = async () => {
  const loginContainer = document.getElementById("login");
  const LOGININFO =
    window.drupalSettings.react.node ||
    (await requestPageData({
      content: "partner",
      nid: loginContainer.dataset.nid,
      langcode: checkLang(),
    }));
  ReactDom.render(<Login data={LOGININFO} />, loginContainer);
  setNewForm();
  validateForm();
  setCurrentPage("login");
  checkNavigation();
};

function setNewForm() {
  const refForm = document.getElementById("refFormLogin");
  const refNewForm = document.getElementById("newFormLogin");

  refNewForm.insertAdjacentElement("beforeend", refForm.children[0]);

  refForm.remove();
}

function validateForm() {
  let validationsMessages: any = {
    field: "Campo Obligatorio",
    email: "Por favor ingrese un email válido",
  };
  var validate = Bouncer("#mx-aguas-firmes-login-form", {
    patterns: {
      email:
        /^[a-z0-9!#$%&'*/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/,
    },
    customValidations: {
      emailVerified: function (field: any) {
        let array_email = field.value.split("@");
        const res = emails.find((m) => m === array_email[1]);
        return res === undefined ? false : true;
      },
    },
    messages: {
      missingValue: {
        default: validationsMessages.field,
      },
      emailVerified: validationsMessages.email,
      patternMismatch: {
        email: validationsMessages.email,
      },
    },
  });
}

function checkNavigation() {
  let getNavigation = performance.getEntriesByType("navigation")[0].toJSON();
  console.log(getNavigation);
  if (getNavigation.type === "back_forward") {
    window.location.reload();
  }
}
